<template lang="pug">
#person
  .person-bg
    .container
      .row
        .col-xs-12.col-sm-6.img-box
          img(:src="person.banner_image | resource")
        .info-box.col-xs-12.col-sm-5.hidden-xs
          .info.fadeAnimation
            h1 {{person.name | multilang}}
            h5 {{person.title | multilang}}
            .social-links
              a(':href'="person.webpage" v-if="person.webpage" target="_blank")
                span.fa-stack
                  i.fa.fa-globe.fa-2x
              a(':href'="person.linkedin" v-if="person.linkedin" target="_blank")
                span.fa-stack
                  i.fa.fa-circle.fa-stack-2x
                  i.fa.fa-linkedin.fa-stack-1x.fa-inverse
  .container
    .row
      .info-box.col-xs-12.visible-xs
        .info(:class="infoAnimation")
          h1 {{person.name | multilang}}
          h5 {{person.title | multilang}}
          .social-links
            a(':href'="person.webpage" v-if="person.webpage" target="_blank")
              span.fa-stack
                i.fa.fa-globe.fa-2x
            a(':href'="person.linkedin" v-if="person.linkedin" target="_blank")
              span.fa-stack
                i.fa.fa-circle.fa-stack-2x
                i.fa.fa-linkedin.fa-stack-1x.fa-inverse
      section.col-xs-12#motto(v-if="haveMotto")
        p(:class="mottoAnimation") {{person.motto | multilang}}

      #bio.col-xs-12
        h1 {{person.spotlight | multilang}}
        p {{{person.bio | multilang}}}

      section.col-xs-12#back
        back-button(':title'="'BACK_TO_TEAM' | wordDict", ':path'="path")
</template>

<script>
import axios from 'axios'
import "animate.css/animate.min.css"
import BackButton from '../back-button.vue'

const fadeInUp = ['animated', 'fadeInDown']
function animation(classes, condition) {
  const ani = {}
  for (const cls of classes) {
    ani[cls] = condition
  }
  return ani
}

export default {
  data () {
    return {
      person: {}
    }
  },
  computed: {
    thumbnailAnimation() {
      const ready = _.has(this.person, 'thumbnail_image')
      return animation(fadeInUp, ready)
    },
    infoAnimation() {
      const ready = _.has(this.person, 'name') || _.has(this.person, 'title')
      return animation(fadeInUp, ready)
    },
    mottoAnimation() {
      const ready = _.has(this.person, 'motto')
      return animation(fadeInUp, ready)
    },
    haveMotto() { return _.has(this.person, 'motto')},
    path() {
      return `/about/team/${this.$route.params.team}?back`
    }
  },
  ready () {},
  created () {
    const personId = this.$route.params.id
    axios.get(`/api/people/${personId.toUpperCase()}`)
          .then((res) => this.person = res.data)
          .catch(function (error) {
            alert(error)

            console.log(error)
          })
  },
  attached () {},
  methods: {},
  components: {
    BackButton
  }
}
</script>

<style lang="scss">
@import "global";
$person-bg-height: 500px;
h1 {
  font-weight: bold;
}
.social-links {
  text-align: center;
  a {
    color: $text-color;
  }
}
.person-bg {
  height: $person-bg-height;
  @media(max-width: #{$screen-xs-max}) {
    height: 166px;
  }
  background-image: url('./images/2-3_1_About_Team_profile_background.jpg');
  .img-box {
    text-align: center;
  }
  img {
    height: $person-bg-height;
    width: auto;
    background-color: rgba(0, 0, 0 , 0);
    @media(max-width: #{$screen-xs-max}) {
      height: 166px;
    }
  }
  .container {
    margin-top: 0;
    background: rgba(0, 0, 0, 0);
    @media(max-width: #{$screen-xs-max}) {
      margin: 0;
    }
    > .row {
      @media(max-width: #{$screen-xs-max}) {
        // background-color: #f8f7f5;
      }
    }
  }
}

.info-box {
  display: table;
  height: $person-bg-height;
  @media(max-width: #{$screen-xs-max}) {
    height: auto;
  }
}

.info {
  @media(max-width: #{$screen-xs-max}) {
    display: block;
  }
  display: table-cell;
  vertical-align: middle;
  h1 {
    text-align: center;
    text-transform: uppercase;
    font-size: 60px;
    letter-spacing: 5px;
    @media(max-width: #{$screen-xs-max}) {
      font-size: 30px;
      letter-spacing: 0.5px;
    }
  }
  h5 {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    @media(max-width: #{$screen-xs-max}) {
      font-size: 18px;
    }
  }
}

#motto, #bio {
  @media (min-width: $grid-float-breakpoint) {
    padding-left: 100px;
    padding-right: 100px;
  }
}

#motto {
  white-space: pre-wrap;
  text-align: center;
  p {
    font-size: 20px;
    text-align: center;
    @media(max-width: #{$screen-xs-max}) {
      font-size: 14px;
    }
  }
  @media(max-width: #{$screen-xs-max}) {
    padding-bottom: 0;
    padding-top: 24px;
  }
}

#bio {
  h1 {
    text-transform: uppercase;
    @media(max-width: #{$screen-xs-max}) {
      font-size: 18px;
      letter-spacing: 0.5px;
    }
  }
  p {
    margin-top: 25px;
    font-size: 16px;
    color: #404047;
    @media(max-width: #{$screen-xs-max}) {
      font-size: 14px;
    }
  }
}

@keyframes fade {
  from {
    transform: translateY(-10%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.fadeAnimation {
  animation-name: fade;
  animation-duration: 1s;
  animation-timing-function: ease-in;
}
</style>



// WEBPACK FOOTER //
// person.vue?0857f298